import { ProfileBackgroundCheckCardProps } from '@/ui/features/accounts';
import { getBackgroundCheckIcon, getBackgroundCheckStatusLabel, isValidBackgroundCheckStatus } from '@/ui/utils/backgroundCheckStatusUtils';
import { TransparentBox } from '@juvare/common-web-ui/TransparentBox';
import { SlideoutScreeningCard } from '@juvare/credentialing/ui/features/credentialing-verification/components';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const SlideoutBackgroundCheckCard: React.FC<ProfileBackgroundCheckCardProps> = ({ backgroundCheckStatus, cardTitle }) => {
    const { t } = useTranslation('rms');
    const { Icon, color } = getBackgroundCheckIcon(backgroundCheckStatus);
    const status = getBackgroundCheckStatusLabel({ status: backgroundCheckStatus, t });
    const isError = backgroundCheckStatus ? !isValidBackgroundCheckStatus(backgroundCheckStatus) : false;

    return (
        <TransparentBox data-test='background-check-box'>
            <SlideoutScreeningCard
                cardTitle={cardTitle ?? t('credentialing.backgroundCheck')}
                icon={<Icon />}
                iconColor={color}
                status={status}
                isError={isError}
            />
        </TransparentBox>
    );
};
